var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"100%"}},[_c('div',{staticClass:"title text-center"},[_vm._v("Course Group")]),_c('course-group-show',{attrs:{"course-group-id":this.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }